export const {
  VITE_ENVIRONMENT,
  VITE_APPKIT_PROJECT_ID,
  VITE_BRIDGE_BASE_API_URL,
  VITE_BRIDGE_NUMBER_OF_ATTESTORS,
  VITE_BRIDGE_NETWORK_TYPE,
  VITE_BRIDGE_RELAYER_PUBLIC_KEY_ECIES,
  VITE_BRIDGE_WALLETCONNECT_PROJECT_ID,
  VITE_BRIDGE_DEFAULT_SECRET,
  VITE_ETHEREUM_TOKENSERVICE_CONTRACT_ADDRESS,
  VITE_ETHEREUM_FEE_COLLECTOR_CONTRACT_ADDRESS,
  VITE_ETHEREUM_PREDICATE_SERVICE_ADDRESS,
  VITE_BASE_PREDICATE_SERVICE_ADDRESS,
  VITE_ARBITRUM_PREDICATE_SERVICE_ADDRESS,
  VITE_ETHEREUM_USDC_TOKEN_ADDRESS,
  VITE_ETHEREUM_USDT_TOKEN_ADDRESS,
  VITE_ETHEREUM_ETH_TOKEN_ADDRESS,
  VITE_ETHEREUM_BRIDGE_CHAIN_ID,
  VITE_ETHEREUM_RPC_URL,
  VITE_BASE_RPC_URL,
  VITE_ALEO_BRIDGE_PROGRAM_NAME,
  VITE_ALEO_TOKENSERVICE_PROGRAM_NAME,
  VITE_ALEO_TOKENSERVICE_PROGRAM_NAME_CD,
  VITE_ALEO_TOKENSERVICE_PROGRAM_ADDRESS,
  VITE_ALEO_MTSP_PROGRAM_NAME,
  VITE_ALEO_COUNCIL_PROGRAM,
  VITE_BRIDGE_ALEO_BASE_URL,
  VITE_BRIDGE_ALEO_NETWORK,
  VITE_ALEO_USDC_TOKENID,
  VITE_ALEO_USDT_TOKENID,
  VITE_ALEO_ETH_TOKENID,
  VITE_ALEO_BRIDGE_CHAIN_ID,
  VITE_ALEO_TOKENID,
  VITE_ALEO_CREDIT_PROGRAM_NAME,
  VITE_BSC_BRIDGE_CHAIN_ID,
  VITE_BSC_WRAPPED_TOKENSERVICE_CONTRACT_ADDRESS,
  VITE_BSC_WRAPPED_ALEO_TOKEN_ADDRESS,
  VITE_BSC_FEE_COLLECTOR_CONTRACT_ADDRESS,
  VITE_BSC_PREDICATE_SERVICE_ADDRESS,
  VITE_BSC_RPC_URL,
  VITE_BASE_USDC_TOKEN_ADDRESS,
  VITE_BASE_BRIDGE_CHAIN_ID,
  VITE_BASE_ETH_TOKEN_ADDRESS,
  VITE_BASE_USDT_TOKEN_ADDRESS,
  VITE_BASE_FEE_COLLECTOR_CONTRACT_ADDRESS,
  VITE_BASE_TOKENSERVICE_CONTRACT_ADDRESS,
  VITE_ARBITRUM_USDC_TOKEN_ADDRESS,
  VITE_ARBITRUM_USDT_TOKEN_ADDRESS,
  VITE_ARBITRUM_BRIDGE_CHAIN_ID,
  VITE_ARBITRUM_ETH_TOKEN_ADDRESS,
  VITE_ARBITRUM_FEE_COLLECTOR_CONTRACT_ADDRESS,
  VITE_ARBITRUM_TOKENSERVICE_CONTRACT_ADDRESS,
  VITE_ARBITRUM_RPC_URL
} = import.meta.env;

// Re-export with bridge-specific naming to avoid conflicts with existing env
export const BRIDGE_NETWORK_TYPE = VITE_BRIDGE_NETWORK_TYPE || 'mainnet';
export const BRIDGE_ALEO_BASE_URL = VITE_BRIDGE_ALEO_BASE_URL || '';
export const BRIDGE_DEFAULT_SECRET = VITE_BRIDGE_DEFAULT_SECRET || '123456';
